import { render, staticRenderFns } from "./tutorial-type.vue?vue&type=template&id=6d9e17a0&scoped=true&"
import script from "./tutorial-type.vue?vue&type=script&lang=js&"
export * from "./tutorial-type.vue?vue&type=script&lang=js&"
import style0 from "./tutorial-type.vue?vue&type=style&index=0&id=6d9e17a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e17a0",
  null
  
)

export default component.exports